// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"adc6dffb","179":"11ac8baf","239":"81c1fd62","377":"5c5b5539","385":"c770874f","453":"5c2d7a9e","455":"54a0369b","570":"2e17d80f","675":"90de5dde","958":"6799778a","977":"5c66c727"}[chunkId] + ".chunk.js";
};